var axios = require('axios');

export const fetchApi1 = async (query, setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount) => {

    // https://supportmonitor.au10tixservicesdev.com
    try {
        const response = await axios({
            method: 'post',
            url: `https://mss.au10tixservicesdev.com/healthcheck`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                "query": query
            })
        })
        const res = response.data.parsedResponse
        if (res.staging.eus.status === 200) {
            setEusstg("#07eb57")
            setEusstgCount(0)
        } if (res.staging.weu.status === 200) {
            setWeustg('#07eb57')
            setWeustgCount(0)
        } if (res.production.wus.status === 200) {
            setWusprd('#07eb57')
            setWusprdCount(0)
        } if (res.production.eus.status === 200) {
            setEusprd('#07eb57')
            setEusprdCount(0)
        } if (res.production.weu.status === 200) {
            setWeuprd('#07eb57')
            setWeuprdCount(0)
        } if (res.production.ejp.status === 200) {
            setEjpprd('#07eb57')
            setEjpprdCount(0)
        } if (res.staging.eus.status === 0) {
            setEusstg("skyblue")
        } if (res.staging.weu.status === 0) {
            setWeustg('skyblue')
        } if (res.production.wus.status === 0) {
            setWusprd('skyblue')
        } if (res.production.eus.status === 0) {
            setEusprd('skyblue')
        } if (res.production.weu.status === 0) {
            setWeuprd('skyblue')
        } if (res.production.ejp.status === 0) {
            setEjpprd('skyblue')
        }
        if (res.staging.eus.status !== 200 && res.staging.eus.status !== 0) {
            setEusstg("red")
            setEusstgCount(count => count + 1)
            console.log("failed on eus stg")
        } if (res.staging.weu.status !== 200 && res.staging.weu.status !== 0) {
            setWeustg("red")
            setWeustgCount(count => count + 1)
            console.log("failed on weu stg")
        } if (res.production.wus.status !== 200 && res.production.wus.status !== 0) {
            setWusprd("red")
            setWusprdCount(count => count + 1)
            console.log("failed on wus prd")
        } if (res.production.eus.status !== 200 && res.production.eus.status !== 0) {
            setEusprd("red")
            setEusprdCount(count => count + 1)
            console.log("failed on eus prd")
        } if (res.production.weu.status !== 200 && res.production.weu.status !== 0) {
            setWeuprd("red")
            setWeuprdCount(count => count + 1)
            console.log("failed on weu prd")
        } if (res.production.ejp.status !== 200 && res.production.ejp.status !== 0) {
            setEjpprd("red")
            setEjpprdCount(count => count + 1)
            console.log("failed on ejp prd")
        }

    } catch (error) {
        console.log(error)
    }

    setTimeout(async () => {
        fetchApi1(query, setEusstg, setWeustg, setEjpprd, setEusprd, setWeuprd, setWusprd, setEusstgCount, setWeustgCount, setEusprdCount, setWeuprdCount, setEjpprdCount, setWusprdCount)
    }, 250000)
}

